import { Button, CircularProgress, Dialog, Grid, Paper, TextField, Typography } from '@material-ui/core';
import { darken } from '@material-ui/core/styles/colorManipulator';
import { WithStyles } from 'decorators/withStyles';
import { IProductOrderBump } from 'interfaces/orderbump';
import React, { ChangeEvent, PureComponent } from 'react';

import RowListBump from './RowList';

interface IProps {
  classes?: any;
  open: boolean;
  products: IProductOrderBump[];
  onClose: Function;
  onSubmit: Function;
}

interface IState {
  searchTerm: string;
  filteredProducts: IProductOrderBump[];
}

@WithStyles(theme => ({
  root: {
    padding: theme.spacing.unit * 2,
    width: '600px',
    [theme.breakpoints.down('md')]: {
      minWidth: 0
    }
  },
  title: {
    fontSize: 20,
    fontWeight: 700,
    letterSpacing: '1.43px',
    color: '#122D44'
  },
  list: {
    overflow: 'auto',
    margin: '16px 0',
    height: 400,
    [theme.breakpoints.down('md')]: {
      height: '60vh'
    }
  },
  product: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '15px 15px',
    cursor: 'pointer',
    '&#children-product': {
      paddingLeft: 32
    }
  },
  productContainer: {
    border: '1px solid #ced4da',
    borderRadius: 4,
    margin: '4px 0'
  },
  productLabel: {
    color: '#565662',
    fontSize: '0.875rem'
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  button: {
    padding: '8px 68px',
    margin: '0 8px',
    backgroundColor: '#596375',
    color: '#fff',
    '&:hover': {
      backgroundColor: darken('#596375', 0.3)
    }
  },
  loader: {
    width: 100,
    height: 100,
    color: '#122D44'
  },
  loaderContainer: {
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  }
}))
export default class ListProductSelection extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      searchTerm: '',
      filteredProducts: []
    };
  }

  handleClose = () => {
    this.props.onClose();
  };

  handleClick = (product: IProductOrderBump) => {
    this.handleClose();
    this.props.onSubmit(product);
  };

  searchProduct = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const searchTerm = event.target.value;
    this.setState({ searchTerm });

    if (searchTerm.length < 3) {
      return;
    }

    const { products } = this.props;

    const filteredProducts = products.filter(
      product =>
        product.title.toLowerCase().includes(searchTerm.toLowerCase()) || product.id.toString().includes(searchTerm)
    );

    this.setState({ filteredProducts });
  };

  render() {
    const { classes, open, products } = this.props;
    const { searchTerm, filteredProducts } = this.state;

    const list = !!searchTerm && searchTerm.length >= 3 ? filteredProducts : products;
    const listItens = list.map(product => (
      <RowListBump
        key={product.id}
        product={product}
        onClick={productOrderBump => this.handleClick(productOrderBump)}
      />
    ));

    const loadingList = (
      <div className={classes.loaderContainer}>
        <CircularProgress className={classes.loader} size="large" color="inherit" />
      </div>
    );

    return (
      <Dialog disableBackdropClick open={open} onClose={this.handleClose}>
        <Paper elevation={0} className={classes.root}>
          <Typography variant="subheading" className={classes.title}>
            Selecione seus produtos
          </Typography>
          <Grid item xs={12}>
            <TextField
              id="search-product"
              name="searchProduct"
              placeholder="Procure seu produto por nome ou ID (pelo menos 3 caracteres)"
              value={searchTerm}
              onChange={this.searchProduct}
              InputProps={{
                disableUnderline: true
              }}
              fullWidth
              margin="normal"
            />
          </Grid>
          <div className={classes.list}>{products.length !== 0 ? listItens : loadingList}</div>
          <div className={classes.actionButtons}>
            <Button className={classes.button} id="cancel-button" onClick={this.handleClose}>
              Fechar
            </Button>
          </div>
        </Paper>
      </Dialog>
    );
  }
}
